<template>
   <div id="qx">
      <el-form ref="form" inline class="form" label-width="110px" size="mini">
         <el-row>
            <el-form-item label="申请人:">
               <p style="width: 200px;">{{ sendDataInfo.opmName }}</p>
            </el-form-item>
            <el-form-item label="申请岗位:">
               <p style="width: 200px;">{{ sendDataInfo.gpmRemark }}</p>
            </el-form-item>
            <el-form-item label="权限模板:">
               <p style="width: 200px;">{{ sendDataInfo.templateNames }}</p>
            </el-form-item>
            <el-form-item label="备注:">
               <p style="width: 200px;">{{ sendDataInfo.remark }}</p>
            </el-form-item>
         </el-row>
      </el-form>
      <div style="display: flex;" v-if="menuList.length>0">
         <div style="width: 40%;margin-right: 20px;">
            <el-tag size="mini" type="danger" style="margin-bottom: 10px;">变更权限</el-tag>
            <el-table stripe highlight-current-row :data="returnData.list" :height="tableHeight" border size="mini" >
               <el-table-column align="center" prop="chType" width="60" label="类型">
                  <template slot-scope="scope">
                     <el-tag size="mini" v-if="scope.row.chType==1">新增</el-tag>
                     <el-tag size="mini" v-else type="danger">取消</el-tag>
                  </template>
               </el-table-column>
               <el-table-column show-overflow-tooltip prop="name" min-width="150" label="权限名称">
               </el-table-column>
            </el-table>
         </div>
         <div style="width: 60%;">
            <el-tag size="mini" style="margin-bottom: 10px;">现有权限</el-tag>
            <el-tabs tab-position="left" type="border-card" :stretch="false" v-model="activeName" @tab-click="handleClick" :style="`margin-right:10px;min-width: 400px;height: ${tableHeight}px;overflow-y: auto;`">
               <el-tab-pane v-for="(menuOne,menuOneKey) in menuList" :label="menuOne.label" :key="menuOneKey" :style="`height: ${tableHeight-30}px;overflow: auto;`">
                  <keep-alive>
                     <el-tree ref="menuTree" :data="[menuOne]" :show-checkbox="true" :check-strictly="true" :expand-on-click-node='false' node-key="jurId" :props="defaultProps" highlight-current
                              :default-expanded-keys="[menuOne.jurId]">
                     </el-tree>
                  </keep-alive>
               </el-tab-pane>
            </el-tabs>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "settingJurisdictionApply1",
   props: ['actionData'],
   data() {
      return {
         tableHeight: 500,
         dataActionBox: {
            actionType: 2
         },
         allMenuList: [],
         menuList: [],
         userJurisdiction: [],
         defaultProps: {
            children: "children",
            label: "label",
         },
         sendDataInfo: {
            opmId: "",
            opmName: "",
            gpmId: "",
            gpmRemark: "",
            powerDetailAdds: [],
            remark: "",
            templateNames:"",
            templateIds:"",
         },
         dataList: [],
         activeName: "",
         tabIndex: 0,
         returnData: {
            list: [],
         },
         firstName: "",
      }
   },
   methods: {
      getValue() {
         return 1
      },
      handleClick(tab, event) {
         console.log(this.activeName);
         this.tabIndex = Number(tab.index)
         this.$refs.menuTree[this.tabIndex].setCheckedKeys(this.userJurisdiction)
      },
      // 获取权限
      async getJurisdictionList() {
         console.log(11111);

         let responseData = await this.$http.getJurisdictionList({ jurType: 0 })  //权限类型权限类型0.erp1.协同
         if (responseData.status == 200) {
            this.menuList = this.handleJurisdiction(responseData.result)
            this.allMenuList = responseData.result
            this.openBox()
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }

      },
      // 权限处理
      handleJurisdiction(data, id = 0, lev = 0) {
         var son = []
         data.forEach((value, keys) => {
            value['selectedStatus'] = false
            value['disabled'] = true
            this.userJurisdiction.forEach((userValue, userKeys) => {
               if (value['jurId'] == userValue['jurId']) {
                  value['selectedStatus'] = true
               }
            })
            if (value['jurParentid'] == id) {
               value['id'] = value['jurId']
               value['value'] = value['jurId']
               value['label'] = value['jurName']
               var list = this.handleJurisdiction(data, value['jurId'], lev + 1);
               if (list.length >= 1) {
                  value['children'] = this.handleJurisdiction(data, value['jurId'], lev + 1);
               }
               son.push(value)
            }
         })
         return son;
      },
      jurListChange(val, data) {

         var list = []
         if (val.jurParentid == 0) {
            this.firstName = val.jurName
         }
         data.forEach(item => {
            if (item.jurId == val.jurParentid && val.jurParentid != 0) {
               list.push(item.jurName)
               list.push(this.jurListChange(item, data)[0])
            }
         })
         return list
      },
      openBox() {
         this.actionData.oldData.powerdetails.forEach((item) => {
            this.userJurisdiction.push(item.id)
         })
         this.returnData.list = []
         this.actionData.oldData.powerChangeDetails.forEach(item => {
            if (item.jurParentid != 0) {
               this.firstName = ""
               var str = ""
               if (this.jurListChange(item, this.allMenuList).reverse()[0] == undefined) {
                  str = this.jurListChange(item, this.allMenuList).reverse().splice(0, 1).join('-')
               } else {
                  str = this.jurListChange(item, this.allMenuList).reverse().join("-")
               }
               var str1 = ""
               if (this.firstName && str.indexOf(this.firstName) == -1) {
                  str1 = `${this.firstName}-${str}-${item.jurName}`
               } else {
                  str1 = `${str}-${item.jurName}`
               }
               this.returnData.list.push({
                  chType: item.chType,
                  name: str1
               })
            }
         })
         this.sendDataInfo.gpmRemark = this.actionData.oldData.gpmRemark
         this.sendDataInfo.opmName = this.actionData.oldData.opmName
         this.sendDataInfo.remark = this.actionData.oldData.remark
         this.sendDataInfo.templateNames = this.actionData.oldData.templateNames
         this.$nextTick(() => {
            this.menuList.forEach((item, index) => {
               this.$refs.menuTree[index].setCheckedKeys([])
               this.$refs.menuTree[index].setCheckedKeys(this.userJurisdiction)
            })
            this.tableHeight = this.heightChange()
         })
      },
      heightChange() {
         var totalHeight = document.documentElement.querySelector(".el-drawer__body").clientHeight
         //顶部按钮
         var headHeight = 0
         var formHeight = 0
         var headTabHeight = 0
         var tableHeight = 0
         if (document.documentElement.querySelector(".el-drawer__body").querySelector(".btns")) {
            headHeight = document.documentElement.querySelector(".el-drawer__body").querySelector(".btns").clientHeight
         }
         if (document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__header")) {
            headTabHeight = document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__header").clientHeight
         }
         var arr = document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__content").childNodes
         arr.forEach(item => {
            if (item.getAttribute("aria-hidden") != 'true') {
               formHeight = item.querySelector("#qx").querySelector(".form").clientHeight
               tableHeight = totalHeight - headHeight - headTabHeight - formHeight - 50
            }
         })
         return tableHeight
      }
   },
   created() {
      this.getJurisdictionList()
   },
}
</script>

<style scoped>
.form {
   padding: 20px 0;
}
#qx ::v-deep .el-tabs--border-card {
   margin-bottom: 0px !important;
}
#qx ::v-deep .el-tabs__header {
   height: 100% !important;
   padding-right: 10px;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
   background-color: #409eff;
   border-color: #409eff;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
   border-color: #fff;
}
</style>